var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.625 10.79V1.585c0-.932.984-1.513 1.769-1.044l8.146 4.873c.802.48.773 1.68-.05 2.118l-8.148 4.331c-.783.417-1.717-.167-1.717-1.073z",
    fill: "#fff"
  })));
}
export default SvgPlayIc;